import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface Site {
  id: string
  domain: string
  baseUrl: string
  verified: boolean
  businessType: string
  createdAt: string
}

export function SitesPage() {
  const t = useT()
  const sites = useQuery({
    queryKey: ['sites'],
    queryFn: () => apiClient.get<{ data: Site[] }>('/sites'),
  })

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">{t('sites.title')}</h1>
        <Link
          to="/onboard"
          className="px-3 py-1.5 text-sm rounded font-medium"
          style={{ background: 'var(--color-accent)', color: 'white' }}
        >
          {t('sites.add')}
        </Link>
      </div>
      {sites.isLoading && <p>{t('common.loading')}</p>}
      {sites.isError && <p>{t('common.error')}</p>}
      {sites.data && sites.data.data.length === 0 && <p className="opacity-70">{t('sites.empty')}</p>}
      {sites.data && sites.data.data.length > 0 && (
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="text-left opacity-70">
              <th className="py-2 pr-4">{t('sites.column.domain')}</th>
              <th className="py-2 pr-4">{t('sites.column.business')}</th>
              <th className="py-2 pr-4">{t('sites.column.verified')}</th>
            </tr>
          </thead>
          <tbody>
            {sites.data.data.map((s) => (
              <tr key={s.id} className="border-t" style={{ borderColor: 'var(--color-border)' }}>
                <td className="py-2 pr-4">
                  <Link to={`/sites/${s.id}`} className="hover:underline">
                    {s.domain}
                  </Link>
                </td>
                <td className="py-2 pr-4 opacity-80">{s.businessType}</td>
                <td className="py-2 pr-4">{s.verified ? '✓' : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
